import { fetcher } from '@commenda/utils';

export interface TemplateSignerInput {
  roleName: string;
  name: string;
  email: string;
}

export interface CreateEnvelopeFromTemplateRequest {
  signatureTemplateId: string;
  serviceRequestTaskId: number;
  /** Must cover the template's roles exactly (one signer per role). */
  signers: TemplateSignerInput[];
}

/**
 * Workflow HUMAN_ESIGN step: create + immediately SEND an envelope from a
 * published signing template. 409 if the task already has an active envelope.
 */
export async function createEnvelopeFromTemplate(
  data: CreateEnvelopeFromTemplateRequest
): Promise<Response> {
  return fetcher('e-signature/envelopes/from-template', {
    method: 'POST',
    body: data,
  });
}
